module.exports = "/packs/media/images/brands/etrade-92a8ef229bc68280270070348bb202e9.png";